export default __webpack_public_path__ + "static/media/calendarMinus.e75b850d.svg";